<script setup>
import { computed } from 'vue';

const props = defineProps({
    field: {
        type: Object,
        required: true,
    },
});

const multipleValuesPossible = computed(() => Array.isArray(props.field.value));
const values = computed(() => (Array.isArray(props.field.value) ? props.field.value : [props.field.value]));
</script>

<template>
    <ul>
        <li
            v-for="value in values"
            :key="value"
            :class="multipleValuesPossible && 'list-disc list-inside'"
        >
            {{ field.options.find(option => option.value === value).label }}
        </li>
    </ul>
</template>
